// Installs the Temporal polyfill when the runtime needs it. Import this module rather than `temporal-polyfill-lite/global`
// or `/shim`: under vitest's vmThreads pool a second entry of that package links a second instance whose install writes
// `undefined` over the global. This module imports no core-js, so a Vercel Edge Runtime entry can import it.
// oxlint-disable-next-line no-restricted-imports -- the one install site the lint rule points to
import { install } from 'temporal-polyfill-lite/shim'

import { needsTemporalPolyfill } from '#@/needsTemporalPolyfill.ts'

// `install(true)` overwrites `Temporal`, `Intl` and `Date.prototype.toTemporalInstant`, the same as the `/global`
// entry. `install(false)` installs only when `globalThis.Temporal` is not an object.
install(needsTemporalPolyfill())
